import { clsx } from 'clsx'

import { StatusDot } from '@buffer-mono/popcorn'

import { LetterAvatar } from '../components/LetterAvatar'

import styles from './CommentAvatar.module.css'

export type CommentAvatarProps = {
  avatar: string
  username: string
  /** render dot for new comments */
  showDot?: boolean
  /** render connector line below the avatar */
  showConnector?: boolean
  /** whether comment has a parent (shows small line above the avatar) */
  hasParent?: boolean
  /** style for the container */
  style?: React.CSSProperties
}

export const CommentAvatar = ({
  avatar,
  username,
  showDot = false,
  showConnector = true,
  hasParent = false,
  style,
}: CommentAvatarProps): JSX.Element => {
  return (
    <div
      className={clsx(styles.container, hasParent && styles.hasParent)}
      aria-hidden
      style={style}
    >
      <div className={styles.avatarContainer}>
        {showDot && <StatusDot className={styles.newCommentDot} />}
        <LetterAvatar
          src={avatar}
          username={username}
          fallbackLetter={username.charAt(0).toUpperCase()}
        />
      </div>
      {showConnector && <div className={styles.verticalLine} />}
    </div>
  )
}

CommentAvatar.displayName = 'CommentAvatar'
